module.exports = __webpack_public_path__ + "img/hobby-logo.a8b89067.png";